import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import styles from '../styles/emptyState.module.scss';
import texts from '../../texts';
import noChangesSearch from '../../../../../../images/noHistorySearch.svg';
import noChanges from '../../../../../../images/noHistory.svg';

export const EmptyState = ({isFastSearch}: {isFastSearch: boolean}) => {
    return (
        <>
            {isFastSearch ? (
                <Flex direction="column" alignItems="center" componentClasses={styles.container}>
                    <img src={noChangesSearch} alt="No changes search" draggable={false} />
                    <Text
                        skin={'paragraph-1'}
                        textColor="primary-700"
                        componentClasses={styles.textWraper}
                    >
                        {texts.changes_empty_state_search}
                    </Text>
                </Flex>
            ) : (
                <Flex direction="column" alignItems="center" componentClasses={styles.container}>
                    <img src={noChanges} alt="No changes" draggable={false} />
                    <Text skin={'paragraph-1'} textColor="primary-700">
                        {texts.changes_empty_state}
                    </Text>
                </Flex>
            )}
        </>
    );
};
